<div class="idv">

  <!-- ── Header ── -->
  <div class="idv__header">
    <span class="idv__label">{{ label }}</span>

    @if (status) {
      <div class="idv__chip idv__chip--{{ statusClass }}">
        <mat-icon class="idv__chip-icon">{{ statusIcon }}</mat-icon>
        {{ parsedStatus.base }}
      </div>
    }

    @if (currentDocId && showSubmitButton) {
      <button
        mat-stroked-button
        class="idv__submit-btn"
        color="primary"
        (click)="onSubmit()"
        matTooltip="Submit this document to identity verification">
        <mat-icon>send</mat-icon> Submit
      </button>
    }
  </div>

  <!-- ── Image area ── -->
  <!--
    Pattern matches mi-report exactly: itfgZoomImage on the container div,
    img as a normal flow child sized by max-height/max-width.
    Overlays (spinner, empty) are position:absolute inside the same container.
    The directive measures the img element's own bounding rect via the host,
    so zoom anchors on the picture — not the dark letterbox bars.
  -->

  <!-- No image yet — plain container, no zoom directive -->
  @if (!imageUrl || loading) {
    <div class="idv__image-wrap">

      @if (prevImageUrl && loading) {
        <img class="idv__image idv__image--ghost" [src]="prevImageUrl" [alt]="label" />
      }

      @if (loading) {
        <div class="idv__overlay">
          <mat-spinner diameter="32" />
        </div>
      }

      @if (!loading && !error && !currentDocId) {
        <div class="idv__overlay idv__overlay--muted">
          <mat-icon>image_not_supported</mat-icon>
          <span>No document linked</span>
        </div>
      }

      @if (!loading && error) {
        <div class="idv__overlay idv__overlay--muted idv__overlay--error">
          <mat-icon>broken_image</mat-icon>
          <span>Could not load image</span>
        </div>
      }

    </div>
  }

  <!-- Image ready — zoom directive on container, img as normal child -->
  @if (imageUrl && !loading) {
    <div class="idv__image-wrap idv__image-wrap--loaded" itfgZoomImage [url]="imageUrl">
      <img class="idv__image" [src]="imageUrl" [alt]="label" />
    </div>
  }

  <!-- ── Footer ── -->
  <div class="idv__footer">
    @if (currentDocId) {
      <span class="idv__mono idv__muted">doc #{{ currentDocId }}</span>
    }
    @if (displayReason) {
      <div class="idv__reason">
        <mat-icon class="idv__reason-icon">warning</mat-icon>
        {{ displayReason }}
      </div>
    }
  </div>

</div>